export default __webpack_public_path__ + "static/media/gift-color-icon.8f15dbbc.svg";